import { Base64 } from './base64';

jQuery(function ($) {
	$('.fix-fouc-block').css('display', 'block');
	// Vendor Panel starts stick at top of page / top of page + button height
	const $VendorPanel = $('.vendorPanel');
	const $AuctionButton = $('#VendorAuctionBtn');
	let $AuctionButtonHeight = $AuctionButton.css('height');

	if ($AuctionButtonHeight == undefined) {
		$AuctionButtonHeight = '0px';
	}

	$VendorPanel.css('top', 'calc(' + $AuctionButtonHeight + ' + 140px');

	const $pageHeaderEl = $('.page-header');
	var timer;

	$(window).on('scroll', function () {
		let scrollHeight = $(this).scrollTop();
		if (window.matchMedia('(min-width: 992px)').matches) {
			$VendorPanel.css('top', 'calc(' + $AuctionButtonHeight + ' + 140px)');
		} else {
			$VendorPanel.css('top', 'calc(' + $AuctionButtonHeight + ' + 90px)');
		}
		if (scrollHeight < 50 && $pageHeaderEl.hasClass('-shrunk')) {
			$pageHeaderEl.removeClass('-shrunk');
		} else if (scrollHeight >= 100) {
			$pageHeaderEl.addClass('-shrunk');
		}
	});

	$(window).on('click', function () {
		$('.modal').removeClass('show-modal');
	});

	$(document).on('click', '.modal__trigger', function () {
		$(this)
			.siblings()
			.toggleClass('show-modal')
			.find('img[data-src]')
			.each(function () {
				$(this)
					.attr('src', this.dataset.src ?? '')
					.removeAttr('data-src');
			});
	});

	$(document).on('click', '.modal__close', function () {
		$(this).closest('.modal').toggleClass('show-modal');
	});

	$(document).on('click', '.modal__trigger, .modal__content', function (event) {
		event.stopPropagation();
	});

	$(document).on('click', '.wantedAd__phoneRevealLink', function () {
		const $phoneEl = $(this).siblings('.wantedAd__phone');
		const decoded_phoneNum = Base64.decode($phoneEl.data('phone'));

		$phoneEl.text(decoded_phoneNum);
		$(this).remove();
	});
	console.log('here');
	$('[data-show-recentlysoldlistings]').on('click', function () {
		$(this).addClass('-active');
		$('[data-show-generallistings]').removeClass('-active');
		$('#GeneralItems').hide();
		$('#RecentlySoldItems').show();
	});

	$('[data-show-generallistings]').on('click', function () {
		$(this).addClass('-active');
		$('[data-show-recentlysoldlistings]').removeClass('-active');
		$('#GeneralItems').show();
		$('#RecentlySoldItems').hide();
	});
});
